import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthorizationService } from '@modules/authorization/services/authorization.service';

export const preAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authorizationService = inject(AuthorizationService);

  if (!authorizationService.isAuthorized()) {
    return true;
  }

  router.navigate(['/']);
  return false;
};
